<div>
    <fieldset>
        <legend>Training Plan Execution</legend>
        <table class="table-auto budget-table mt-2">
        
            <tbody>
                <tr>
                    <td class="w-25 bg-sky">Training Name</td>
                    <td class="w-25">Dragon Fruit Farming</td>
                    <td class="w-25 bg-sky">Training Venue</td>
                    <td class="w-25">Jharagram</td>
                </tr>
                <tr>
                    <td class="w-25 bg-sky">Start Date</td>
                    <td class="w-25">10-11-2025</td>
                    <td class="w-25 bg-sky">End Date</td>
                    <td class="w-25">12-11-2025</td>
                </tr>
                <tr>
                    <td class="w-25 bg-sky">Budget Head</td>
                    <td class="w-25">B.2.3.5</td>
                    <td class="w-25 bg-sky">Mode of Training</td>
                    <td class="w-25">Residential</td>
                </tr>
                <tr>
                    <td class="w-25 bg-sky">Type of Participants</td>
                    <td class="w-25 bg-yellow">New</td>
                    <td class="w-25 bg-sky">Duration</td>
                    <td class="w-25 bg-yellow">2 Days</td>
                </tr>

                <tr>
                    <td class="w-25 bg-sky">Training KIT</td>
                    <td class="w-25 bg-yellow">Yes</td>
                    <td class="w-25 bg-sky">Training Materials / Handout</td>
                    <td class="w-25 bg-yellow">Yes</td>
                </tr>
                <tr>
                    <td class="w-25 bg-sky">Refreshment Needed</td>
                    <td class="w-25 bg-yellow" colspan="3"> Yes </td>
                </tr>
            </tbody>
        </table>
    </fieldset>    
    <fieldset class="mt-2">
        <legend>Training Attandance</legend>
                <div *ngFor="let p of executedata; let i = index">
                    <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-3">
                        <div>
                            <mat-form-field appearance="outline">
                                <mat-label>Training Date</mat-label>
                                <input matInput [matDatepicker]="picker" [value]="p.dates | date:'yyyy-MM-dd'">
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div>
                            <!-- Start Time -->
                            <mat-form-field appearance="outline">
                                <mat-label>Start Time</mat-label>
                                <input matInput type="time" >
                            </mat-form-field>
                        </div>
                        <div>
                            <!-- End Time -->
                            <mat-form-field appearance="outline">
                                <mat-label>End Time</mat-label>
                                <input matInput type="time" >
                            </mat-form-field>
                        </div>
                        <div>
                            <button type="button" class="btn-action-update" (click)="navigateToattandanceentry(p.id, p.dates)">
                                <span class="material-symbols-outlined">how_to_reg</span>
                                Attendance Details
                            </button>
                        </div>
                    </div>    
                </div>
      
    </fieldset>  
    
</div>
